import React, { FC, Fragment } from 'react';

import { SearchGroupsQueryVariables } from 'api';
import { IEmptyState, EmptyState } from 'components';
import { useGroupSearch } from 'hooks';

import GroupListFollow from './GroupListFollow';
import Loader from './Loader';

interface IProps {
  emptyStateName: keyof IEmptyState;
  variables: SearchGroupsQueryVariables;
}

const QueryList: FC<IProps> = ({ emptyStateName, variables }) => {
  const { results, isExhausted, isEmpty, isInitialLoad, sentinelRef } = useGroupSearch(variables);

  if (isEmpty) {
    return <EmptyState name={emptyStateName} />;
  }

  if (isInitialLoad) {
    return <Loader />;
  }

  return (
    <Fragment>
      <GroupListFollow
        emptyStateName={emptyStateName}
        groups={results}
        isExhausted={isExhausted}
        sentinelRef={sentinelRef}
      />
    </Fragment>
  );
};

export default QueryList;
